export default __webpack_public_path__ + "static/media/LouizaRodrigues.ead6bd75.png";